angular
	.module 'App.Repository'
	.factory 'IntegrationErrorRepository', ['BaseRepository', (BaseRepository) ->
		class IntegrationErrorRepository extends BaseRepository
			@resource = '/integration_errors'
			@isRestricted = true

		return new IntegrationErrorRepository()
	]
